module.exports = __webpack_public_path__ + "static/render2wide-d6d3a4404a5cd1ba2c7d370ba88bef70.png";